export * from "just-split";
export { default } from "just-split";
